import axios from 'axios';

const apiKey = 'AIzaSyDAnAIxHQBW39nb5pht-hCI6aL6gos4X0o'; // Reemplaza 'TU_API_KEY' con tu clave de API de Google Maps


// const Api = 'https://clmb.ximagroup.com.mx/api/';
// const Api = 'https://dev.ximagroup.com.mx/api/';return

class TodoDataService {



  GetHost() {
    //const Host = 'https://clmb.proximasistemas.com.mx/';
    const Host = 'https://columbafunerales.com/';
      // const Host = 'https://192.168.1.66:80/';
    // const Host = 'https://192.168.1.160/';
    return Host;
  }
  GetHost2() {
    // const Host = 'https://clmb.proximasistemas.com.mx';
    const Host = 'https://columbafunerales.com';
      // const Host = 'https://192.168.1.66:80'; 
    // const Host = 'https://192.168.1.160';

    return Host;
  }

  GetHostRestApi() {
    //  const Host = 'https://clmb.ximagroup.com.mx/api';
    const Host = 'https://columba.ximagroup.com.mx/api';
    return Host;
  }



 GetNumberPhone = () => {
  const phone = '5217227844321'; // sin el signo +
  const message = "Visité su página web y me interesan sus servicios";

  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
}

  GetNumberCall = () => {
    const Phone = '722-7844-321';
    return Phone;
  }




  GetNumberCall2 = () => {
    const Phone = '7227844321';

    return Phone;
  }

  GetEmailCall = () => {
    const Phone = 'contacto@columbafunerales.com';

    return Phone;
  }

  GetEmail() {
    const Email = 'contacto@columbafunerales.com'
    return 'mailto:' + encodeURIComponent(Email) + "?subject=Contratacion%20de%20servicio&body=Estoy%20interesado%20en%20contratar"
  }



  capitalize = str =>
    str.split(' ')
      .map(([first, ...rest]) => [first.toUpperCase(), ...rest].join(''))
      .join(' ');


  capitalizeEachWord = (text) => {
    const words = text.toLowerCase().split(" ");
    const wordsCapitalized = words.map(word => this.capitalize(word));
    return wordsCapitalized.join(" ");
  }


  ValidarFolioCliente = async (OnclickActionData) => {

    axios.defaults.headers.common["Authorization"] = OnclickActionData.Token;

    await axios.request(OnclickActionData.Url2 + OnclickActionData.Data.PedidoClienteFolio).then(response => {
      axios.request(OnclickActionData.Url3 + OnclickActionData.Data.PedidoClienteFolio + '/144').then(response => {
        OnclickActionData.Refresh({ Error: 'Ya existe una conmemeoracion para el folio ingresado' })
      }).catch(error => {
        OnclickActionData.Refresh({ PedidoCliente: response.data });
        axios.request(OnclickActionData.Url + OnclickActionData.Data.PedidoClienteFolio).then(response => {
          OnclickActionData.Refresh({ ValidatePedidoClienteFolio: true, OpenConmemoracion: false, DataFinado: { agnoDefuncion: response.data.agnoDefuncion, agnoNacimiento: response.data.agnoNacimiento, nombreCompleto: this.capitalizeEachWord(response.data.nombreCompleto), setFunerario: this.capitalizeEachWord(response.data.setFunerario), sexo: this.capitalizeEachWord(response.data.sexo) } });
        }).catch(error => {
          console.log(error);
          OnclickActionData.Refresh({ Error: error.response.data.errores })
        })
      })
    }).catch(error => {
      console.log(error);
      OnclickActionData.Refresh({ Error: error.response.data.errores.mensaje })
    })

    // await 
  }



  PeticionGet = async (Data) => {
    axios.defaults.headers.common["Authorization"] = Data.Token;
    await axios.request(Data.Url).then(response => {
      Data.Save({ [Data.NameKey]: response.data });
    }).catch(error => {
      console.log(error);
    })
  }


  ConvertBase64ToBlob = async (extencionFoto, foto) => {
    const blob = await fetch(extencionFoto + ',' + foto);
    return (URL.createObjectURL(await blob.blob()));
  }




  PeticionGetComemoraciones = async (Data) => {
    axios.defaults.headers.common["Authorization"] = Data.Token;
    let ListConmemoracion = []
    await axios.request(Data.Url1).then(response => {
      ListConmemoracion = response.data
    }).catch(error => {
      console.log(error);
    })

    const DataConmeracionCaratula = await Promise.all(
      ListConmemoracion.map(async (conmemoracion) => ({
        Conmemoracion: conmemoracion,
        Caratula: await this.consulto(Data.Url2 + conmemoracion.folioOrigen)
      }))
    )

    let DataConmemoracionCaratulaFilter = DataConmeracionCaratula.filter((element) => (element.Caratula !== undefined && element.Caratula.foto !== null && element.Caratula.extencionFoto !== null))
    let prueba = await Promise.all(DataConmemoracionCaratulaFilter.map(async (element) => ({
      Caratula:
      {
        agnoDefuncion: element.Caratula.agnoDefuncion,
        agnoNacimiento: element.Caratula.agnoNacimiento,
        foto: await this.ConvertBase64ToBlob(element.Caratula.extencionFoto, element.Caratula.foto),
        nombreCompleto: this.capitalizeEachWord(element.Caratula.nombreCompleto),
        setFunerario: this.capitalizeEachWord(element.Caratula.setFunerario),
        sexo: element.Caratula.sexo,
      }
      , Conmemoracion: element.Conmemoracion
    })))
    Data.Save({
      [Data.NameKey]: prueba
    });

  }

  PeticionGetComemoracionesBusqueda = async (Data) => {
    axios.defaults.headers.common["Authorization"] = Data.Token;
    let ListConmemoracion = []
    await axios.request(Data.Url1).then(response => {
      ListConmemoracion = response.data
    }).catch(error => {
      console.log(error);
      Data.Error();
    })

    const DataConmeracionCaratula = await Promise.all(
      ListConmemoracion.map(async (conmemoracion) => ({
        Conmemoracion: conmemoracion,
        Caratula: await this.consulto(Data.Url2 + conmemoracion.folioOrigen)
      }))
    )

    let DataConmemoracionCaratulaFilter = DataConmeracionCaratula.filter((element) => (element.Caratula !== undefined && element.Caratula.foto !== null && element.Caratula.extencionFoto !== null))
    let prueba = await Promise.all(DataConmemoracionCaratulaFilter.map(async (element) => ({
      Caratula:
      {
        agnoDefuncion: element.Caratula.agnoDefuncion,
        agnoNacimiento: element.Caratula.agnoNacimiento,
        foto: await this.ConvertBase64ToBlob(element.Caratula.extencionFoto, element.Caratula.foto),
        nombreCompleto: this.capitalizeEachWord(element.Caratula.nombreCompleto),
        setFunerario: this.capitalizeEachWord(element.Caratula.setFunerario),
        sexo: element.Caratula.sexo,
      }
      , Conmemoracion: element.Conmemoracion
    })))
    Data.Save({
      [Data.NameKey]: prueba
    });

  }






  peticionPost = async (Data) => {
    let DataC = { folioOrigen: Data.Conmemoracion.FolioOrigen, operacionOrigen: Data.Conmemoracion.OperacionOrigen, folioReferencia: '', operacionReferencia: '', mensaje: Data.Conmemoracion.Mensaje, foto: Data.Conmemoracion.FotoVideo, extencionFoto: Data.Conmemoracion.ExtencionFoto, video: Data.Conmemoracion.Video, extencionVideo: Data.Conmemoracion.ExtencionVideo }
    axios.defaults.headers.common["Authorization"] = Data.Token;
    await axios.post(Data.Url, DataC).then(response => {
      Data.Refresh();
    }).catch(error => {
      Data.SetError({ ConmemoracioError: error });
      console.log(error);
    });
  }


  PostMemoria = async (Data) => {
    axios.defaults.headers.common["Authorization"] = Data.Token;
    await axios.post(Data.Url, Data.Memoria).then(response => {
      axios.request(this.GetHostRestApi() + '/Conmemoraciones/memorias/' + Data.Memoria.folio).then(response => {
        Data.Refresh(response.data, 'DataNuevaMemoria', 'Conmemoracion');
        Data.Close();
      }).catch(error => {
        console.log(error);
      })
    }).catch(error => {
      console.log(error);
    });
  }


  consulto = async (url) => {

    let result = '';
    await axios.request(url).then(response => {
      result = response
    }).catch(error => {
      console.log(error)
    })

    return result.data;
  }


  ValidarCupon = async (Data) => {
    axios.defaults.headers.common["Authorization"] = Data.Token;
    const respuesta = await axios.request(Data.Url + Data.Data.FolioCupon)
    console.log(respuesta);
    if (respuesta.data.cantidad !== 0) {
      if (respuesta.data.tipo === 'P') {
        Data.SetError({ FormPago: { ...Data.Data, CuponValido: true, Descuento: Data.Total * respuesta.data.cantidad / 100 } });


      }
      if (respuesta.data.tipo === 'I') {
        Data.SetError({ FormPago: { ...Data.Data, CuponValido: true, Descuento: respuesta.data.cantidad } });
      }

    }
    else {
      Data.SetError({ FormPago: { ...Data.Data, CuponValido: false, Descuento: 0, Error: ['Verifica tu cupón!'] } });
    }
  }


  GetNuevaMemoria = async (Data, Caratula, Folio) => {
    axios.defaults.headers.common["Authorization"] = Data.Token;
    Data.Refresh({ DataNuevaMemoria: { Conmemoracion: '', Caratula: Caratula } });
    Data.Close();
    await axios.get(Data.Url + Folio).then(response => {
      Data.Refresh({ DataNuevaMemoria: { Conmemoracion: response.data, Caratula: Caratula } });
    }).catch(error => {
      console.log(error);
    });
  }


  GetNuevaMemoriaCompartir = async (Data) => {
    axios.defaults.headers.common["Authorization"] = Data.Token;
    let datacaratula = await this.PeticionGetComemoracionesNuevaMemoriaCompartir({ Token: Data.Token, Url1: Data.Url1, Url2: Data.Url2 });
    console.log(Data.Folio);
    Data.Refresh({ NuevaMemoria: true, DataConmemoracion: datacaratula, Compartir: true, DataNuevaMemoria: { Conmemoracion: '', Caratula: datacaratula.find((element) => element.Conmemoracion.folio.trim() === Data.Folio).Caratula } });
    // Data.Close();
    await axios.get(Data.Url3 + Data.Folio).then(response => {
      let Memoria = response;
      Data.Refresh({ NuevaMemoria: true, DataConmemoracion: datacaratula, Compartir: true, DataNuevaMemoria: { Conmemoracion: Memoria.data, Caratula: datacaratula.find((element) => element.Conmemoracion.folio === Data.Folio).Caratula } });
    }).catch(error => {
      console.log(error);
    });
  }


  PeticionGetComemoracionesNuevaMemoriaCompartir = async (Data) => {
    axios.defaults.headers.common["Authorization"] = Data.Token;
    let ListConmemoracion = ''
    await axios.request(Data.Url1).then(response => {
      ListConmemoracion = response.data
    }).catch(error => {
      console.log(error);
    })

    const DataConmeracionCaratula = await Promise.all(
      ListConmemoracion.map(async (conmemoracion) => ({
        Conmemoracion: conmemoracion,
        Caratula: await this.consulto(Data.Url2 + conmemoracion.folioOrigen)
      }))
    )

    let DataConmemoracionCaratulaFilter = DataConmeracionCaratula.filter((element) => (element.Caratula !== undefined && element.Caratula.foto !== null && element.Caratula.extencionFoto !== null))
    let prueba = await Promise.all(DataConmemoracionCaratulaFilter.map(async (element) => ({
      Caratula:
      {
        agnoDefuncion: element.Caratula.agnoDefuncion,
        agnoNacimiento: element.Caratula.agnoNacimiento,
        foto: await this.ConvertBase64ToBlob(element.Caratula.extencionFoto, element.Caratula.foto),
        nombreCompleto: this.capitalizeEachWord(element.Caratula.nombreCompleto),
        setFunerario: this.capitalizeEachWord(element.Caratula.setFunerario),
        sexo: element.Caratula.sexo,
      }
      , Conmemoracion: element.Conmemoracion
    })))

    return prueba;

  }





  PostNuevoservicio = async (Data) => {
    // let Respuesta='';
    axios.defaults.headers.common["Authorization"] = Data.Token;
    await axios.post(this.GetHostRestApi() + '/PedidoCliente', Data.DataResponsable).then(response => {
      let Respuesta = response.data;
      let DataFinado = Object.assign(Data.DataFinado, { folioPedido: Respuesta.folio })
      axios.post(this.GetHostRestApi() + '/Finado', DataFinado).then(response => {
        Data.Close();
      }).catch(error => {
        console.log(error);
      })
      Data.Refresh('FormPago', 'PedidoCliente', Respuesta);
    }).catch(error => {
      console.log(error);
    });
  }





  PostAnticipoCliente = async (Data, Token, OnClickClose, SetError) => {
    try {
      axios.defaults.headers.common["Authorization"] = Token;
      await axios.post(this.GetHostRestApi() + '/Anticipos', Data);
      await this.PutAutorizar(Data.FolioOrigen, Token, OnClickClose);
    } catch (error) {
      SetError(true);
      console.error("Error en PostAnticipoCliente:", error);
    }
  };

  PutAutorizar = async (Folio, Token, OnClickClose, SetError) => {
    try {
      axios.defaults.headers.common["Authorization"] = Token;
      await axios.put(this.GetHostRestApi() + '/pedidocliente/autorizar/' + Folio);
      OnClickClose();
    } catch (error) {
      SetError(true);
      console.error("Error en PutAutorizar:", error);
    }
  };

  PostGenerarCliente = async (DataResponsable, Save, Error, Close, Token) => {
    let datapost = { codEstab: '2', nombre: DataResponsable.Nombre, apPaterno: DataResponsable.ApellidoPaterno, apMaterno: DataResponsable.ApellidoMaterno, tel1: DataResponsable.TelefonoPrimario, tel2: DataResponsable.TelefonoSecundario, email: DataResponsable.Email }
    axios.defaults.headers.common["Authorization"] = Token;
    await axios.post(this.GetHostRestApi() + '/clientes', datapost).then(response => {
      Save('FormPago', 'KeyCliente', response.data.codCte);
      Close();
    }).catch(error => {
      console.log(error);
      let errores = [];
      errores.push(error.response.data.errores.mensaje)
      Error(errores);
    });
  }

  PostRespuestaOpenPay = async (OpenPay, PedidoCliente, Token) => {
    let DataResponsable = {
      folioOrigen: PedidoCliente.Folio,
      operacionOrigen: PedidoCliente.Operacion,
      idOpenpay: OpenPay.id,
        authorization : OpenPay?.authorization || '',
        method : OpenPay.method,
        operationType:OpenPay.operation_type,
        transactionType:OpenPay.transaction_type,
        status:OpenPay.status,
        conciliated:OpenPay?.conciliated || false,
        creationDate:OpenPay.creation_date,
        operationDate:OpenPay.operation_date,
        description:OpenPay.description,
        errorMessage:'',
        amount:OpenPay.amount,
        currency:OpenPay.currency,
        orderId : OpenPay?.order_id || '',
        paymentMethodType: OpenPay.payment_method.type,
        paymentMethodUrl: OpenPay.payment_method?.url || '',
        paymentMethodReference: OpenPay.payment_method?.reference || '',
        paymentMethodPaybinReference: OpenPay.payment_method?.paybin_reference || '',
        paymentMethodBarcodeUrl: OpenPay.payment_method?.barcode_url || '',
        paymentMethodPaybinUrl: OpenPay.payment_method?.paybin_url || '',
        paymentMethodAgreement: OpenPay.payment_method?.agreement || '',
        paymentMethodClabe: OpenPay.payment_method?.clabe || '',
        paymentMethodBank: OpenPay.payment_method?.bank || '',
        paymentMethodName: OpenPay.payment_method?.name || '',

        customerName: OpenPay.customer?.name || '',
        customerLastName: OpenPay.customer?.last_name || '',
        customerEmail: OpenPay.customer?.email || '',
        customerPhoneNumber: OpenPay.customer?.phone_number || '',
        customerCreationDate: OpenPay.customer?.creation_date || '',
        customerClabe: OpenPay.customer?.clabe || '',
        customerExternalId: OpenPay.customer?.external_id || '',
        usuario:'1'
    }
    axios.defaults.headers.common["Authorization"] = Token;
    await axios.post(this.GetHostRestApi() + '/OpenpayRespuestas', DataResponsable).then(response => {

    }).catch(error => {
      console.log(error);
    });
  }


  
   getDistanceBetweenPoints = (latitude1, longitude1, latitude2, longitude2, unit = 'kilometers') => {
    let theta = longitude1 - longitude2;
    let distance = 60 * 1.1515 * (180 / Math.PI) * Math.acos(
      Math.sin(latitude1 * (Math.PI / 180)) * Math.sin(latitude2 * (Math.PI / 180)) +
      Math.cos(latitude1 * (Math.PI / 180)) * Math.cos(latitude2 * (Math.PI / 180)) * Math.cos(theta * (Math.PI / 180))
    );
    if (unit === 'miles') {
      return Math.round(distance, 2);
    } else if (unit === 'kilometers') {
      return Math.round(distance * 1.609344, 2);
    }
  }

CoverturaCP = async (cp) => {
  const lat = 19.2536973 ;
  const lng =  -99.5923868;
    // Llamar a la API de Google Maps Geocoding para obtener las coordenadas
    const respuesta = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${cp}|country:MX&key=${apiKey}`  
    )
    const result = await respuesta.json();
    // Actualizar el estado del mapa con las coordenadas obtenidas

    // Calcular la distancia entre puntos
    const distance = this.getDistanceBetweenPoints(result.results[0].geometry.location.lat, result.results[0].geometry.location.lng, lat, lng);
    // Verificar si la distancia está dentro de la cobertura
    if (distance <= 50) {
     return true;
    } else {
      return  false
   }
  }




  
  PostEmailComprovante = async (Data, Token) => {
    try {
      axios.defaults.headers.common["Authorization"] = Token;
      await axios.post(this.GetHostRestApi() + '/email', Data);
    } catch (error) {
      // SetError('Error en el envio de comprobante');
      console.error("Error en el envio de comprobante:", error);
    }
  };



  GetOpenPayCredenciales = async (Token) => {

    let result = '';
          axios.defaults.headers.common["Authorization"] = Token;
    await axios.request(this.GetHostRestApi() + '/pagos/openpaycredenciales').then(response => {
      result = response.data
    }).catch(error => {
      console.log(error)
    })

    return result;
  }


  OpenpayCargoDebitoCredito = async (Data,Url,Token) =>
  {
    let result = '';
    axios.defaults.headers.common["Authorization"] = Token;
    await axios.post(Url, Data).then(response => {
      result = response.data;
      console.log(result);
    }).catch(error => {
      console.log(error);
    });
    return result
  }
  


GetListTestimonios = async (Url,Url2, Token) => {
  let result = [];
  axios.defaults.headers.common["Authorization"] = Token;

  try {
    const response = await axios.get(this.GetHostRestApi() + Url);
    result = response.data;
  } catch (error) {
    console.log(error);
  }

  if (result.length > 0) {
    result = await Promise.all(
      result.map(async (item) => {
        const fotoBlob = (await axios.get(
          this.GetHostRestApi() + Url2 + item.profilePhotoUrl,
          { responseType: 'blob' } // 📌 recibe directamente binario
        )).data;

        return {
          ...item,
          profilePhotoUrl: URL.createObjectURL(fotoBlob) // 📌 listo para <img src=...>
        };
      })
    );
  }

  return result;
};



}
export default new TodoDataService();
